import Util from '../utils/util';
import Clazz from '../common/Clazz';

/**
 * 通用的编辑结果对象
 */
export default class EditResult extends Clazz {
    /**
     * 构造方法
     */
    constructor(data, options) {
        super(options);

        Object.assign(this, data);
    }

    /**
     * 克隆方法
     */
    clone() {
        const data = {};
        for (const [key, val] of Object.entries(this)) {
            if (key !== 'options') {
                data[key] = Util.clone(val);
            }
        }

        return new EditResult(data, this.options);
    }
}
